import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog } from "@inductiveautomation/ws-components";

import InductiveAutomationLogo from "../../../assets/images/inductive_automation_logo.png";
import TestinviteLogo from "../../../assets/images/testinvite-logo-5-bg-white.png";
import { TrainingDialogProps } from "../Training.types";
import { getDialogStyles } from "../_training.styles";

const OpenTest = ({ action, onClose, openTestUrl }: TrainingDialogProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "training.actions.open_test.dialog",
  });
  const { classes } = getDialogStyles();

  const [showTestLink, setShowTestLink] = useState(false);

  useEffect(() => {
    if (action === "open-test" && openTestUrl) {
      // automatically navigate to test after 2 seconds
      setTimeout(() => {
        window.open(openTestUrl);
      }, 2000);
      // if navigation has not occurred after 2.5 seconds, show link
      setTimeout(() => {
        window.open(openTestUrl);
        if (document.visibilityState === "visible") {
          setShowTestLink(true);
        } else {
          onClose();
        }
      }, 2500);
    }
  }, [action, onClose, openTestUrl, setShowTestLink]);

  return (
    <Dialog
      isOpen={action === "open-test"}
      testId="open-test-dialog"
      headline={t("heading")}
      showCloseButton={showTestLink}
      contentArea={
        <div className={classes.imageContainer}>
          <img
            src={InductiveAutomationLogo}
            alt={t("inductive_automation_logo_alt_text")}
          />
          <img src={TestinviteLogo} alt={t("testinvite_logo_alt_text")} />
        </div>
      }
      helper={
        showTestLink
          ? {
              text: (
                <>
                  If you are not automatically redirected,{" "}
                  <Button
                    href={openTestUrl}
                    target="_blank"
                    buttonVariant="text"
                    onClick={onClose}
                  >
                    click here
                  </Button>
                </>
              ),
            }
          : undefined
      }
      collapseHelper={true}
      onClose={onClose}
    />
  );
};

export default OpenTest;
